import React, { useState, useEffect } from 'react';
import { TransactionDocumentsAPI } from '../services/api';

interface DocumentUploadButtonProps {
  recordId: string;
  onClick: () => void;
}

export const DocumentUploadButton: React.FC<DocumentUploadButtonProps> = ({ recordId, onClick }) => {
  const [count, setCount] = useState<number>(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCount();
  }, [recordId]);

  const loadCount = async () => {
    try {
      setLoading(true);
      const response = await TransactionDocumentsAPI.getDocumentCount(recordId);
      setCount(response.count);
    } catch (err) {
      console.error('Failed to load document count:', err);
      setCount(0);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      className="document-upload-btn"
      onClick={onClick}
      title={count > 0 ? `${count} document(s) attached` : 'Attach documents'}
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="12" y1="18" x2="12" y2="12" />
        <line x1="9" y1="15" x2="15" y2="15" />
      </svg>
      {!loading && count > 0 && (
        <span className="document-count-badge">{count}</span>
      )}

      <style>{`
        .document-upload-btn {
          position: relative;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 32px;
          height: 32px;
          padding: 0;
          border: 1px solid var(--border-primary);
          border-radius: 4px;
          background: var(--bg-card);
          color: var(--text-secondary);
          cursor: pointer;
          transition: all 0.2s ease;
        }

        .document-upload-btn:hover {
          background: var(--bg-hover);
          color: var(--primary);
          border-color: var(--primary);
        }

        .document-count-badge {
          position: absolute;
          top: -6px;
          right: -6px;
          min-width: 18px;
          height: 18px;
          padding: 0 5px;
          font-size: 10px;
          font-weight: 600;
          line-height: 18px;
          text-align: center;
          color: white;
          background: var(--primary);
          border-radius: 9px;
        }
      `}</style>
    </button>
  );
};
